import gql from 'graphql-tag';

export const getCompanies = gql`
  query getCompanies {
    getCompanies {
      id
      name
      abbreviation
      enabled
      companyCode
    }
  }
`;
